import { render, staticRenderFns } from "./FinancialHighlights.vue?vue&type=template&id=2fe23e96&scoped=true&"
import script from "./FinancialHighlights.vue?vue&type=script&lang=js&"
export * from "./FinancialHighlights.vue?vue&type=script&lang=js&"
import style0 from "./FinancialHighlights.vue?vue&type=style&index=0&id=2fe23e96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe23e96",
  null
  
)

export default component.exports